$(function() {
  if(!$('html.articles.new-from-url').length) {
    return false;
  }

  $('form.create-from-url').on('submit', function(e) {
    $('#loading-modal').modal('show');
  });
});
